module.exports = __webpack_public_path__ + "img/snpark_gallery4.ffc3e73b.jpg";